import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { saas } from "@/lib/saasApi";

const AuthCtx = createContext(null);
export const useAuth = () => useContext(AuthCtx);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [org, setOrg] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const { data } = await saas.me();
      setUser(data.user);
      setOrg(data.organisation);
    } catch {
      setUser(null);
      setOrg(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const login = async (email, password) => {
    const { data } = await saas.login(email, password);
    await refresh();
    return data.user;
  };
  const register = async (payload) => {
    const { data } = await saas.register(payload);
    await refresh();
    return data;
  };
  const logout = async () => {
    try { await saas.logout(); } catch { /* */ }
    setUser(null);
    setOrg(null);
  };

  return (
    <AuthCtx.Provider value={{ user, org, loading, refresh, login, register, logout, setUser }}>
      {children}
    </AuthCtx.Provider>
  );
}

export function ProtectedRoute({ children, roles }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return <div className="flex min-h-screen items-center justify-center text-re-muted">Loading…</div>;
  if (!user) return <Navigate to="/login" replace state={{ from: location }} />;
  if (user.mustChangePassword && location.pathname !== "/account/password") return <Navigate to="/account/password" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to={user.role === "OWNER_ADMIN" ? "/admin" : "/dashboard"} replace />;
  return children;
}
